import styled from "styled-components"
import { colors } from "../../utils/colors";

import Footer from "./Footer";
import FAQ from "./FAQs";
import StayUpdated from "./StayUpdated";

const Container = styled('div')`
display: flex;
flex-direction: column;
align-items: stretch;
border-top: 1px solid ${colors.grey400};
width: 100%;
box-sizing: border-box;
`

const FooterSection = () => {
    return (
      <Container>
        <FAQ/>
        <StayUpdated/>
        <Footer/>
      </Container>
    );
  };
  
  export default FooterSection;